export const permissionConstants = {
  normalPermission: ['writer', 'editor', 'moderator', 'admin', 'super'],
  editorPermission: ['editor', 'moderator', 'admin', 'super'],
  moderatorPermission: ['moderator', 'admin', 'super'],
  adminPermission: ['admin', 'super'],
  superAdminPermission: ['super']
};
